import React, { Suspense } from 'react';

const CodeEditor = React.lazy(() => import('./CodeEditor'));

/**
 * @typedef {import('./type').Props} Props
 */

/**
 * lazy加载包装
 * @param {Props} props
 *  */
export default function CodeMirrorLight(props) {
  return (
    <Suspense fallback={<div />}>
      <CodeEditor {...props} />
    </Suspense>
  );
}
